// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: EQLrGnDQznap
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import NotPaidStatusCard from "../../NotPaidStatusCard"; // plasmic-import: _cS0bXBnpQMQ/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicPaymentInstance.module.css"; // plasmic-import: EQLrGnDQznap/css
import Line6Icon from "./icons/PlasmicIcon__Line6"; // plasmic-import: mO1R9Y3ZlHer/icon
import image9CNpoqbJsUhR from "./images/image9.png"; // plasmic-import: _CNpoqbJsUhR/picture

createPlasmicElementProxy;

export const PlasmicPaymentInstance__VariantProps = new Array();

export const PlasmicPaymentInstance__ArgProps = new Array(
  "paymentType",
  "paymentAmount",
  "createdDate1",
  "createdDate2",
  "paymentSuccessDate",
  "clientCompany",
  "paymentMethod",
  "cancelType2",
  "cancelType3"
);

const $$ = {};

function PlasmicPaymentInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
            />

            <div
              data-plasmic-name={"figmaPaste"}
              data-plasmic-override={overrides.figmaPaste}
              className={classNames(projectcss.all, sty.figmaPaste)}
            >
              <div className={classNames(projectcss.all, sty.freeBox___2FdKd)}>
                {renderPlasmicSlot({
                  defaultContents: " ",
                  value: args.paymentAmount,
                  className: classNames(sty.slotTargetPaymentAmount)
                })}
                <div
                  data-plasmic-name={"paymentStatusStack"}
                  data-plasmic-override={overrides.paymentStatusStack}
                  className={classNames(projectcss.all, sty.paymentStatusStack)}
                >
                  <NotPaidStatusCard
                    data-plasmic-name={"notPaidStatusCard"}
                    data-plasmic-override={overrides.notPaidStatusCard}
                    className={classNames(
                      "__wab_instance",
                      sty.notPaidStatusCard
                    )}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__wJLy3)}>
                {renderPlasmicSlot({
                  defaultContents: " ",
                  value: args.paymentType,
                  className: classNames(sty.slotTargetPaymentType)
                })}
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"optionStack"}
                data-plasmic-override={overrides.optionStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.optionStack)}
              >
                <div
                  data-plasmic-name={"stopAutomation"}
                  data-plasmic-override={overrides.stopAutomation}
                  className={classNames(projectcss.all, sty.stopAutomation)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__epcVa
                    )}
                  >
                    {"Stop Automation"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"editSubscription"}
                  data-plasmic-override={overrides.editSubscription}
                  className={classNames(projectcss.all, sty.editSubscription)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__cb3Ud
                    )}
                  >
                    {"Edit Subscription"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"voidPayment"}
                  data-plasmic-override={overrides.voidPayment}
                  className={classNames(projectcss.all, sty.voidPayment)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__kG6T)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "Void Payment",
                      value: args.cancelType2,
                      className: classNames(sty.slotTargetCancelType2)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"markAsPaid"}
                  data-plasmic-override={overrides.markAsPaid}
                  className={classNames(projectcss.all, sty.markAsPaid)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__elUp)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "Mark As Paid",
                      value: args.cancelType3,
                      className: classNames(sty.slotTargetCancelType3)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"refundButton"}
                  data-plasmic-override={overrides.refundButton}
                  className={classNames(projectcss.all, sty.refundButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___343Qw
                    )}
                  >
                    {"Refund"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"receiptButton"}
                  data-plasmic-override={overrides.receiptButton}
                  className={classNames(projectcss.all, sty.receiptButton)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__uTfu
                    )}
                  >
                    {"View Receipt"}
                  </div>
                </div>
              </Stack__>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__eZhl1)}>
              <div className={classNames(projectcss.all, sty.freeBox__sePoH)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lzISu
                  )}
                >
                  {"Date"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__gxhXo)}>
                  {renderPlasmicSlot({
                    defaultContents: " ",
                    value: args.createdDate1,
                    className: classNames(sty.slotTargetCreatedDate1)
                  })}
                </div>
              </div>
              <div
                className={classNames(projectcss.all, sty.freeBox___9Bqwr)}
              />

              <div className={classNames(projectcss.all, sty.freeBox__m6KKt)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__rEAiM
                  )}
                >
                  {"Customer"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__kidF6)}>
                  {renderPlasmicSlot({
                    defaultContents: " ",
                    value: args.clientCompany,
                    className: classNames(sty.slotTargetClientCompany)
                  })}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__tPoU2)} />
              <div className={classNames(projectcss.all, sty.freeBox___2FOy)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__saJ0
                  )}
                >
                  {"Payment Method"}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__pXAre)}>
                  {renderPlasmicSlot({
                    defaultContents: " ",
                    value: args.paymentMethod,
                    className: classNames(sty.slotTargetPaymentMethod)
                  })}
                </div>
              </div>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__cdZxn
              )}
            >
              {"Payment History"}
            </div>
            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Notes"}
            </div>
            <Line6Icon
              data-plasmic-name={"svg"}
              data-plasmic-override={overrides.svg}
              className={classNames(projectcss.all, sty.svg)}
              role={"img"}
            />

            <div className={classNames(projectcss.all, sty.freeBox___6Y2L0)}>
              {renderPlasmicSlot({
                defaultContents: " ",
                value: args.paymentSuccessDate,
                className: classNames(sty.slotTargetPaymentSuccessDate)
              })}
            </div>
            <div
              data-plasmic-name={"paymentLinkStack"}
              data-plasmic-override={overrides.paymentLinkStack}
              className={classNames(projectcss.all, sty.paymentLinkStack)}
            >
              <div
                data-plasmic-name={"paymentLink"}
                data-plasmic-override={overrides.paymentLink}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.paymentLink
                )}
              >
                {"Payment Link Created"}
              </div>
              <PlasmicImg__
                data-plasmic-name={"paymentLinkImage"}
                data-plasmic-override={overrides.paymentLinkImage}
                alt={""}
                className={classNames(sty.paymentLinkImage)}
                displayHeight={"4%"}
                displayMaxHeight={"none"}
                displayMaxWidth={"4%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loading={"lazy"}
                src={{
                  src: image9CNpoqbJsUhR,
                  fullWidth: 256,
                  fullHeight: 256,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__aPbo4)}>
              {renderPlasmicSlot({
                defaultContents: " ",
                value: args.createdDate2,
                className: classNames(sty.slotTargetCreatedDate2)
              })}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__wj9Qv
              )}
            >
              {"Payment Succeeded"}
            </div>
            <div
              data-plasmic-name={"rectangle50"}
              data-plasmic-override={overrides.rectangle50}
              className={classNames(projectcss.all, sty.rectangle50)}
            >
              <textarea
                data-plasmic-name={"paymentNotes"}
                data-plasmic-override={overrides.paymentNotes}
                className={classNames(
                  projectcss.all,
                  projectcss.textarea,
                  sty.paymentNotes
                )}
                ref={ref => {
                  $refs["paymentNotes"] = ref;
                }}
                value={"This is a text area."}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "topBar",
    "figmaPaste",
    "paymentStatusStack",
    "notPaidStatusCard",
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton",
    "title",
    "svg",
    "paymentLinkStack",
    "paymentLink",
    "paymentLinkImage",
    "rectangle50",
    "paymentNotes"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "topBar",
    "figmaPaste",
    "paymentStatusStack",
    "notPaidStatusCard",
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton",
    "title",
    "svg",
    "paymentLinkStack",
    "paymentLink",
    "paymentLinkImage",
    "rectangle50",
    "paymentNotes"
  ],

  topBar: ["topBar"],
  figmaPaste: [
    "figmaPaste",
    "paymentStatusStack",
    "notPaidStatusCard",
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton"
  ],

  paymentStatusStack: ["paymentStatusStack", "notPaidStatusCard"],
  notPaidStatusCard: ["notPaidStatusCard"],
  optionStack: [
    "optionStack",
    "stopAutomation",
    "editSubscription",
    "voidPayment",
    "markAsPaid",
    "refundButton",
    "receiptButton"
  ],

  stopAutomation: ["stopAutomation"],
  editSubscription: ["editSubscription"],
  voidPayment: ["voidPayment"],
  markAsPaid: ["markAsPaid"],
  refundButton: ["refundButton"],
  receiptButton: ["receiptButton"],
  title: ["title"],
  svg: ["svg"],
  paymentLinkStack: ["paymentLinkStack", "paymentLink", "paymentLinkImage"],
  paymentLink: ["paymentLink"],
  paymentLinkImage: ["paymentLinkImage"],
  rectangle50: ["rectangle50", "paymentNotes"],
  paymentNotes: ["paymentNotes"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentInstance__ArgProps,
          internalVariantPropNames: PlasmicPaymentInstance__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentInstance";
  } else {
    func.displayName = `PlasmicPaymentInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentInstance = Object.assign(
  // Top-level PlasmicPaymentInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    topBar: makeNodeComponent("topBar"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    paymentStatusStack: makeNodeComponent("paymentStatusStack"),
    notPaidStatusCard: makeNodeComponent("notPaidStatusCard"),
    optionStack: makeNodeComponent("optionStack"),
    stopAutomation: makeNodeComponent("stopAutomation"),
    editSubscription: makeNodeComponent("editSubscription"),
    voidPayment: makeNodeComponent("voidPayment"),
    markAsPaid: makeNodeComponent("markAsPaid"),
    refundButton: makeNodeComponent("refundButton"),
    receiptButton: makeNodeComponent("receiptButton"),
    title: makeNodeComponent("title"),
    svg: makeNodeComponent("svg"),
    paymentLinkStack: makeNodeComponent("paymentLinkStack"),
    paymentLink: makeNodeComponent("paymentLink"),
    paymentLinkImage: makeNodeComponent("paymentLinkImage"),
    rectangle50: makeNodeComponent("rectangle50"),
    paymentNotes: makeNodeComponent("paymentNotes"),
    // Metadata about props expected for PlasmicPaymentInstance
    internalVariantProps: PlasmicPaymentInstance__VariantProps,
    internalArgProps: PlasmicPaymentInstance__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPaymentInstance;
/* prettier-ignore-end */
